import { useSelector } from "react-redux";

export const useScheduleColors = (session, events, academic_group) => {
    const { tiny_name } = useSelector((state) => state.config);

    const status = {
        owner: "#3174ad",
        no_owner: "#767676",
        no_teacher: "#EA7F20",
        compacted: "#763EC1",
    };

    const getColor = (index) => {
        // Lógica para generar colores dinámicos basados en el id del evento
        const colors = [
            "#069e2d",
            "#276fbf",
            "#087e8b",
            "#de3c4b",
            "#ff715b",
            "#ff69b4",
            "#201e50",
            "#ff8c00", // Dark Orange
            "#4682b4", // Steel Blue
            "#dc143c", // Crimson
            "#2e8b57", // Sea Green
            "#49306b",
            "#9e6240",
            "#f56476",
            "#240115",
            "#ff4500",
            "#008080", // Teal
            "#2d3142",
            "#ff1493", // Deep Pink
            "#042a2b",
            "#800000", // Maroon
            "#006400", // Dark Green
            "#ff7f00", // Vibrant Orange
            "#228b22", // Forest Green
            "#1e90ff", // Dodger Blue
            "#cd5c5c", // Indian Red
            "#2f4f4f", // Dark Slate Gray
            "#32cd32",
        ];

        if (index < colors.length) {
            //* Usar solo los colores del array
            return colors[index];
        }

        //* Generar colores aleatoriamente
        const hue = (index * 137) % 360; // Distribución por ángulo dorado
        const saturation = 65; // Saturación fija para consistencia
        const lightness = 38; // Luminosidad fija para asegurar legibilidad

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;

        //* Si se terminan los colores, usar un color por defecto
        // return index < colors.length ? colors[index] : "#d3d3d3";

        //* Asignación cíclica de colores
        // return colors[index % colors.length];
    };

    function getColorForEvent(event, events, getColor) {
        // Función auxiliar para obtener valores únicos basados en una clave anidada
        function getUniqueValues(events, key) {
            return [
                ...new Set(
                    events.map((item) => {
                        const keys = key.split(".");
                        return keys.reduce(
                            (acc, curr) => acc && acc[curr],
                            item
                        );
                    })
                ),
            ];
        }

        // Función auxiliar para obtener colores para una lista de valores únicos
        function getColorsForList(list) {
            return list.map((_, index) => getColor(index));
        }

        // Función auxiliar para obtener el color basado en un valor específico
        function getColorForValue(list, value) {
            const index = list.indexOf(value);

            return index !== -1 ? getColorsForList(list)[index] : null;
        }

        let listOfClass = [];
        let color = null;

        switch (event.category) {
            case "deportes":
                listOfClass = getUniqueValues(events, "sub_category_sports");
                color = getColorForValue(
                    listOfClass,
                    event.sub_category_sports
                );
                break;

            case "idiomas":
                listOfClass = getUniqueValues(
                    events,
                    "schedules_extracurricular_ids"
                );
                color = getColorForValue(
                    listOfClass,
                    event.schedules_extracurricular_ids
                );
                break;

            default:
                // if (!event.schedules_ids) {
                //     listOfClass = getUniqueValues(events, "class.cve_subject");
                //     color = getColorForValue(
                //         listOfClass,
                //         event.class.cve_subject
                //     );
                // } else {
                //     listOfClass = getUniqueValues(events, "schedules_ids");
                //     color = getColorForValue(listOfClass, event.schedules_ids);
                // }

                listOfClass = getUniqueValues(events, "schedules_ids");
                color = getColorForValue(listOfClass, event.schedules_ids);

                break;
        }

        return color;
    }

    const eventPropGetter = (event) => {
        const getEventColor = () => {
            //* Determinar la clave para asignar los colores
            const getKey = (ev) => {
                return tiny_name === "EAD"
                    ? ev?.module
                    : ev?.class?.cve_subject;
            };

            const listOfClass = [
                ...new Set(events.map((item) => getKey(item))),
            ];
            const colors = listOfClass.map((_, index) => getColor(index));
            const index = listOfClass.indexOf(getKey(event));

            switch (session) {
                case "teacher":
                case "student": {
                    return colors[index];
                }
                case "operator":
                    if (!academic_group?.id) {
                        return colors[index];
                    } else {
                        if (event.academic_group_id !== academic_group?.id) {
                            if (event.compacted) {
                                return status.compacted; //morado
                            } else {
                                return status.no_owner; //gris
                            }
                        } else if (!event.teacher_id) {
                            return status.no_teacher; //naranja
                        } else if (
                            event.academic_group_id === academic_group?.id
                        ) {
                            if (event.compacted) {
                                return status.compacted; //morado
                            } else {
                                //owner

                                const colorByEvent = getColorForEvent(
                                    event,
                                    events,
                                    getColor
                                );

                                return colorByEvent;
                            }
                        }
                    }

                default:
                    return ""; // Color predeterminado en caso de no coincidir con ningún caso
            }
        };

        //regresa los estilos de colores en las clases de los calendarios(docente estudiante) grupo actual operador
        return {
            style: {
                ...event.style,
                backgroundColor: getEventColor(),
                borderColor: "#1e1e1e",
                color: "white",
            },
        };
    };

    return {
        eventPropGetter,
    };
};
